module.exports = __webpack_public_path__ + "img/animals_mouse.00158f14.png";